


























































import { isEqual } from "lodash";
import { Component, Emit, Mixins } from 'vue-property-decorator'

import SettingWrapper from "../../../SettingWrapper.vue";
import FieldWrapper from '../../components/FieldWrapper.vue'
import { InputFieldSettings, InputFieldEmits } from '../../mixins'
import { SearchTextInputProps, SearchTextInputSearchEvent } from "./types";

@Component({
  components: {
    SettingWrapper,
    FieldWrapper,
  },
})
export default class SearchTextInput extends Mixins<InputFieldSettings<SearchTextInputProps>, InputFieldEmits>(InputFieldSettings, InputFieldEmits) {
  @Emit()
  search(value: string, event: MouseEvent): SearchTextInputSearchEvent {
    return { value, event }
  }

  mounted() {
    if (this.settings.settingWrapper !== undefined) {
      const trimmedValue = (this.value ?? '').toString().trim()
      const trimmedDisabledOrActiveValue = this.disabledOrActiveValue.toString().trim()

      this.disabledSettingValueActive = isEqual(trimmedDisabledOrActiveValue, trimmedValue) || ((this.$slots['value-stub'] ?? false) && isEqual(trimmedDisabledOrActiveValue, trimmedValue))
    }
  }
}
